import { Error } from '@/components';
import errorImage from '/server-error.svg';

const NotFound = () => {
  return <Error imageSrc={errorImage} errorTitle={'404'} />;
};

export default NotFound;
